import dateFormat from 'dateformat';

export const getPEStampPDFName = (projectId: string) => {
  const now = new Date();
  const date = dateFormat(now, 'yyyymmdd');

  return `${projectId.toLocaleUpperCase()}_pe_stamp_report_${date}`;
};

